import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {useCheckoutBasketItems} from '../../scayle-state/useCheckoutBasketItems';
import {ProductDetailsSlot} from './ProductDetailsSlot';

export interface ProductDetailsSlotsProps {
  ProductDetailsLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const ProductDetailsSlots: React.FC<ProductDetailsSlotsProps> = ({
  ProductDetailsLayoutComponent,
}) => {
  const basketItems = useCheckoutBasketItems();

  return (
    <>
      {basketItems.map(item => (
        <ProductDetailsSlot
          key={item.id}
          checkoutItemId={item.id}
          productId={item.productId}
          LayoutComponent={ProductDetailsLayoutComponent}
        />
      ))}
    </>
  );
};
